<template>
	<div :class="[width || 'w-full', height || 'h-6']">
		<div class="h-full rounded" :class="preloaderClass" />
	</div>
</template>

<script setup>
defineProps({
	width: {
		type: String,
		required: false,
	},
	height: {
		type: String,
		required: false,
	},
	preloaderClass: {
		type: String,
		default: 'content-loader-animate',
		required: false,
	},
})
</script>
